import { VerticalAlignValue } from 'highcharts';

import { BaseChart } from '@/components/Charts';

interface Series {
  name?: string;
  data: { y: number; color?: string }[];
}

interface TabConfig {
  label: string;
  value: string;
}

type SeriesByTab = Record<string, Series[]>;

type CategoriesByTab = Record<string, string[]>;

interface ColumnChartProps {
  title: string;
  subtitle?: string;
  series: Series[] | SeriesByTab;
  categories: string[] | CategoriesByTab;
  formatValue?: (val: number) => string | JSX.Element;
  headerTooltip?: string;
  headerStats?: { label: string; value: number }[];
  tabsList?: TabConfig[];
  hasTotal?: boolean;
  customColors?: string[];
  legendVerticalAlignment?: VerticalAlignValue;
  titleClassName?: string;
  showDataLabels?: boolean;
  tooltipFormatter?: Highcharts.TooltipFormatterCallbackFunction;
}

export const ColumnChart = ({
  customColors,
  legendVerticalAlignment,
  ...rest
}: ColumnChartProps) => {
  return (
    <BaseChart
      chartType="column"
      customOptions={{
        ...(customColors ? { colors: customColors } : {}),
        plotOptions: {
          column: {
            borderRadius: 0,
          },
        },
        legend: {
          ...(legendVerticalAlignment
            ? { verticalAlign: legendVerticalAlignment }
            : {}),
        },
      }}
      {...rest}
    />
  );
};
